<!-- Mobile Footer -->
<footer class="d-md-none d-block">
  <nav class="nav-icons-container">
    <ul class="list-unstyled d-flex justify-content-around m-0 p-0">
      <li [ngClass]="{'active': selectedMenu == '/'}" (click)="makeActive('/')">
        <i class="pi pi-home"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == '/cart'}" (click)="makeActive('/cart')">
        <span class="cart-bubble" *ngIf="cart?.length > 0">{{cart?.length}}</span>
        <i class="pi pi-shopping-cart"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == '/user/profile'}" (click)="makeActive('/user/profile')">
        <i class="pi pi-user"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == 'reach-us'}" (click)="makeActive('reach-us')">
        <i class="pi pi-mobile"></i>
      </li>
    </ul>
  </nav>
</footer>

<!-- Web Footer -->
<footer class="text-center text-lg-start bg-light text-muted d-none d-md-block">
  <!-- Section: Social media -->
  <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
    <!-- Left -->
    <div class="me-5 d-none d-lg-block">
      <span>Get connected with us on social networks:</span>
    </div>
    <!-- Left -->

    <!-- Right -->
    <div>
      <a href="https://www.facebook.com/SmartDukaanIndiaOfficial/" class="me-4 text-reset">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a href="https://twitter.com/smartdukaan" class="me-4 text-reset">
        <i class="fab fa-twitter"></i>
      </a>
      <a href="https://www.google.com/maps/place/SMART+DUKAAN/@25.7351199,82.6819091,17z/data=!3m1!4b1!4m6!3m5!1s0x39903b99921a1569:0xe85e8d720cdfd76a!8m2!3d25.7351199!4d82.6819091!16s%2Fg%2F11mw7r8xvy?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D" class="me-4 text-reset">
        <i class="fab fa-google"></i>
      </a>
      <a href="https://www.instagram.com/smartdukaan/?hl=en" class="me-4 text-reset">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="https://in.linkedin.com/company/smartdukaan" class="me-4 text-reset">
        <i class="fab fa-linkedin"></i>
      </a>
    </div>
    <!-- Right -->
  </section>
  <!-- Section: Social media -->
  <!-- Section: Links  -->
  <section class="">
    <div class="container text-center text-md-start mt-5">
      <!-- Grid row -->
      <div class="row mt-3">
        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">About</h6>
          <p><a routerLink="/reach-us" class="text-reset">Contact Us</a></p>
          <p><a href="https://franchise.smartdukaan.com#about" target="_blank" class="text-reset">About Us</a></p>
          <p><a href="https://franchise.smartdukaan.com/career.php" target="_blank" class="text-reset">Careers</a></p>
          <p><a href="https://franchise.smartdukaan.com/#whysmartDukaan" target="_blank" class="text-reset">Why SmartDukaan</a></p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">Help</h6>
          <p><a href="#!" class="text-reset">Payments</a></p>
          <p><a href="#!" class="text-reset">Shipping</a></p>
          <p><a [routerLink]="['/return-policy']" class="text-reset">Cancellation and Return</a></p>
          <p><a href="#!" class="text-reset">FAQ</a></p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">Consumer Policy</h6>
          <p><a [routerLink]="['/terms']" class="text-reset">Terms Of Use</a></p>
          <p><a [routerLink]="['/privacy-policy']" class="text-reset">Privacy and Policy</a></p>
          <p><a [routerLink]="['/return-policy']" class="text-reset">Return Policy</a></p>
          <p><a [routerLink]="['/disclaimer-policy']" class="text-reset">Disclaimer</a></p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
          <p><i class="fas fa-home me-3"></i>Smart Dukaan</p>
          <p style="margin-left:0px;">New Spice Solutions Pvt Ltd Priska Tower, <br> 2nd Floor, C-56/45, C Block, Industrial Area
            Phase 2 Sector 62, Noida - 201309  </p>
          <p><i class="fas fa-envelope me-3"></i>{{'care@smartdukaan.com'}}</p>
          <p><i class="fas fa-phone me-3"></i>18002700273</p>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </div>
  </section>
  <!-- Section: Links  -->

  <!-- Copyright -->
  <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
    All rights reserved. © 2017-{{currentYear}}: Owned by NEW SPICE SOLUTIONS PRIVATE LIMITED
  </div>
  <!-- Copyright -->
</footer>
